import {CapabilitiesContextType} from '../app-context';

/**
 * [Unleash] サーバーから受け取った capabilities を UI 方針に合わせて正規化する。
 *
 * 本家 6.4x はコメント API が常に `dislikes: true` を返し、いいねが 👍/👎 UI
 * （並び順も net_score）へ切り替わる。Unleash では従来のハート UI・いいね順を
 * 維持する方針のため、state へ取り込む際に dislikes を必ず無効化する。
 * これにより LikeButton のハート分岐（テキスト色設定の適用を含む）・
 * DislikeButton 非表示・いいね順ソートが一貫して旧挙動になる。
 */
export function sanitizeCapabilities(capabilities: CapabilitiesContextType | undefined): CapabilitiesContextType {
    return {
        ...(capabilities ?? {}),
        dislikes: false
    };
}
